import React from 'react';

import { EMPTY_VALUE } from '../lib/formatters';
import { cn } from '../lib/utils';

export interface NameOverSlugProps {
  name?: string | null;
  /** The second line: an alias or slug. Nothing is rendered when it is empty. */
  secondary?: string | null;
  /** Monospace second line (identifiers). Default true. */
  mono?: boolean;
  className?: string;
}

/**
 * A record's name over its alias or slug (admin lens and template Name cells,
 * Running Processors Template). EMPTY_VALUE when the name is absent — never an id.
 */
export const NameOverSlug: React.FC<NameOverSlugProps> = ({ name, secondary, mono = true, className }) => (
  <div className={cn('min-w-0', className)}>
    <p className={cn('truncate text-sm', !name && 'text-muted-foreground')}>{name || EMPTY_VALUE}</p>
    {secondary ? (
      <p className={cn('truncate text-xs text-muted-foreground', mono && 'font-mono')}>{secondary}</p>
    ) : null}
  </div>
);

export interface OrganizationCellProps {
  name?: string | null;
  slug?: string | null;
  className?: string;
}

/**
 * Whose row this is, in a table that can hold more than one organization's rows
 * (DESIGN_SYSTEM.md §6.1 Ownership): the organization's name over its slug in
 * small muted mono. Takes no id on purpose — an organization UUID is never shown.
 */
export const OrganizationCell: React.FC<OrganizationCellProps> = ({ name, slug, className }) => (
  <NameOverSlug name={name} secondary={slug} className={className} />
);
